import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=3bcb4f03&scoped=true&lang=pug"
var script = {}
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=3bcb4f03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb4f03",
  null
  
)

export default component.exports